import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

// Back-button hook with a deep-link fallback.
//
// ``navigate(-1)`` alone is the wrong primitive when a user can land
// directly on a route — opening /history from a notification, a PWA
// shortcut, or a paste-into-address-bar leaves no SPA history to pop,
// and the chevron either no-ops or pops the browser into a previous
// origin, both confusing.
//
// React Router v6 stamps ``window.history.state.idx`` on every entry
// it pushes; the initial load sits at idx 0, every subsequent push
// increments. ``idx > 0`` therefore means "there's an SPA entry
// behind us we can safely pop." When false, we route to the caller-
// supplied fallback so the chevron always lands somewhere useful.
//
// Returns a stable callback (useCallback) so it can be passed as a
// prop without churning re-renders.
export function useBackOrFallback(fallbackPath) {
  const navigate = useNavigate();
  return useCallback(() => {
    const idx = window.history?.state?.idx;
    if (typeof idx === "number" && idx > 0) {
      navigate(-1);
    } else {
      navigate(fallbackPath, { replace: true });
    }
  }, [navigate, fallbackPath]);
}
